import { render } from "./WebhooksWebshops.vue?vue&type=template&id=737d38fb"
import script from "./WebhooksWebshops.vue?vue&type=script&lang=js"
export * from "./WebhooksWebshops.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__